'use strict'

export function geoService (http) {
	return {
		loadLocation: () => {
			return http.jsonrpc(
				'/rpc/2.0/geo',
				'loadLocation'
			).then((resp) => {
				return resp.result
			})
		},

		loadCountryList: () => {
			return http.jsonrpc(
				'/rpc/2.0/geo',
				'loadCountryList'
			).then((resp) => {
				return resp.result
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/e24-services/geo-service.js